import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { getCartUserId } from "../utils/cartUser";
import { getLocalCartItems } from "../utils/localCart";
import "./FloatingCartButton.css";

export default function FloatingCartButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const [cartCount, setCartCount] = useState(0);

  const fetchCartCount = useCallback(async () => {
    const userId = getCartUserId();
    const localItems = getLocalCartItems(userId);

    try {
      const res = await fetch(`https://gp-live-backend.vercel.app/api/cart/${userId}`);
      if (!res.ok) {
        setCartCount(localItems.length);
        return;
      }

      const data = await res.json();
      const serverCount = Array.isArray(data) ? data.length : 0;
      setCartCount(serverCount + localItems.length);
    } catch {
      setCartCount(localItems.length);
    }
  }, []);

  useEffect(() => {
    fetchCartCount();
  }, [fetchCartCount]);

  useEffect(() => {
    window.addEventListener("cartUpdated", fetchCartCount);
    window.addEventListener("focus", fetchCartCount);
    return () => {
      window.removeEventListener("cartUpdated", fetchCartCount);
      window.removeEventListener("focus", fetchCartCount);
    };
  }, [fetchCartCount]);

  if (cartCount < 1 || location.pathname === "/cart") {
    return null;
  }

  return (
    <button
      type="button"
      className="floating-cart-btn"
      aria-label="Open cart"
      onClick={() => navigate("/cart")}
    >
      <ShoppingCart size={20} />
      <span className="floating-cart-badge">
        {cartCount > 99 ? "99+" : cartCount}
      </span>
    </button>
  );
}
